import type { PrefabData } from "./prefabData";
import { BlastDoor } from "../../things/blastDoor.ts";
import { SlidingDoor } from "../../things/slidingDoor.ts";
import { Direction } from "../../direction.ts";
import { GraySlab } from "../../things/floors/graySlab.ts";
import { MetalBlock } from "../../things/metalBlock.ts";
import { OpenBlastDoorsTerminal } from "../../things/openBlastDoorsTerminal.ts";
import { BaseKeyCard } from "../../items/baseKeyCard.ts";
import { BaseKeyCardLootBox } from "../../things/baseKeyCardLootBox.ts";

export const robotBaseEntranceData: PrefabData = {
	legend: {
		"/": { class: "BlastDoor", props: { group: "robotBaseEntrance" } },
		".": "DarkConcreteFloor",
		D: { class: "Downstairs", props: { destination: 0 } },
		E: "EmptyBarrel",
		"#": "MetalBlock",
		"+": "MetalDoor",
		M: "MetalLootBox",
		R: { class: "RobotEntranceTerminal", props: { group: "robotBaseEntrance" } },
		A: { class: "RobotSpawner", props: { active: false, spawns: "CaveRobot" } },
		",": "WarningFloor",
	},
	layers: [
		[
			"     .       ",
			"     .       ",
			"     . .. ...",
			"    .. ,,    ",
			"     . ..... ",
			"     . ..... ",
			"     . ..... ",
			"     . ..    ",
			"       ..    ",
			"       ..    ",
			"       ..    ",
			"..     ..    ",
			".,.........  ",
			".,.........  ",
			"..     ....  ",
			"       ...   ",
			"             ",
		],
		[
			"    #+#      ",
			"    # #######",
			"    # #EE#MM+",
			"    / #  ####",
			"    # #     #",
			"    # #   D #",
			"    # #     #",
			"    #R#  ####",
			"    ###  ### ",
			"    ###  ### ",
			"   ####  ### ",
			"  #####  ### ",
			"  /       A# ",
			"  /       A# ",
			"  #####   A# ",
			"     ##AAA## ",
			"      #####  ",
		],
	],
};

export const finalBranchStairData: PrefabData = {
	borderRequired: true,
	legend: {
		"#": MetalBlock.key,
		",": GraySlab.key,
		"+": { class: BlastDoor.key, props: { group: "baseArchivesDoor" } },
		T: { class: OpenBlastDoorsTerminal.key, props: { group: "baseArchivesDoor", requiredItem: BaseKeyCard.key } },
		D: { class: "Downstairs", props: { destination: 0 } },
	},
	layout: [
		"#####",
		"# D #",
		"#   #",
		"##+##",
		",,,T,",
		",,,,,"
	],
};

export const fortressData: PrefabData = {
	legend: {
		".": "GrayStoneFloor2",
		$: "LootBox",
		"#": "MetalBlock",
		"/": "MetalDoor",
		R: "Robot",
	},
	layers: [
		[
			"            ",
			" ..      .. ",
			" .......... ",
			"  ........  ",
			"     ..     ",
			"  ........  ",
			"  .. .. ..  ",
			"     ..     ",
			"  ........  ",
			" .......... ",
			" ..      .. ",
			"            ",
		],
		[
			"####    ####",
			"#RR######RR#",
			"#R   $$$  R#",
			"##        ##",
			" ####  #### ",
			" #$$/  /$$# ",
			" #$$#  #$$# ",
			" ####  #### ",
			"##        ##",
			"#R        R#",
			"#RR###/##RR#",
			"####    ####",
		],
	],
};
